module.exports = __webpack_public_path__ + "img/Consulting.6cca60d6.png";